const UGCPolicy = () => {
    return (
        <div
            className='wp-block-themeisle-blocks-tabs-item__content active'
            role='tabpanel'
        >
            <h4
                id='wp-block-themeisle-blocks-advanced-heading-0128676d'
                className='wp-block-themeisle-blocks-advanced-heading wp-block-themeisle-blocks-advanced-heading-0128676d'
            >
                <strong>Política de Conteúdo Gerado pelo Usuário (UGC)</strong>
            </h4>

            <p>
                <strong>
                    Última revisão: 24 de outubro de 2024
                    <br />
                    Data de vigência: 24 de outubro de 2024
                </strong>
            </p>

            <p>
                A Netdoor criou este guia de Propriedade Intelectual do Jogo
                ("IP do Jogo") para fornecer diretrizes aos criadores que
                desejam criar conteúdo gerado pelo usuário ("UGC") baseado nos
                jogos oferecidos através do site Plyosgame e seus sites
                afiliados (doravante "plyosgames").
            </p>

            <p>
                A IP do Jogo refere-se a todos os materiais protegidos por
                direitos autorais e propriedade intelectual relacionados aos
                jogos da plyosgames, incluindo, mas não se limitando a,
                universo, história, personagens, monstros, imagens, músicas de
                fundo, vídeos, etc.
            </p>

            <p>
                UGC refere-se a obras derivadas criadas pelos usuários baseadas
                na IP do jogo plyosgames, incluindo mercadorias, vídeos de jogo
                (como streams de gameplay e filmes de fãs), fan art e fan
                fiction.
            </p>

            <p>
                <strong>O uso comercial do UGC é proibido.</strong>
            </p>

            <p>
                Você não deve solicitar ou receber compensação monetária pela
                criação de UGC.
                <br />
                Você não pode vender, exibir ou fornecer acesso ao UGC em troca
                de compensação financeira.
                <br />
                Você não pode submeter UGC em competições que ofereçam
                incentivos financeiros ou utilizem comercialmente seus envios.
            </p>

            <p>
                <strong>
                    Apesar das restrições acima, o seguinte uso de UGC é
                    permitido:
                </strong>
            </p>

            <p>
                Você pode carregar UGC em plataformas de conteúdo de acesso
                gratuito (como YouTube, Twitch, Facebook) e gerar receita com
                anúncios ou doações. Isso inclui UGC que utilize diretamente a
                trilha sonora do jogo.
            </p>

            <p>
                Ao criar UGC, os criadores devem cumprir todas as leis de
                direitos autorais e outros regulamentos legais, os termos de
                serviço da plyosgames, a política de privacidade e as políticas
                de operação do jogo, além de respeitar os bons costumes e a
                ordem social.
            </p>

            <p>
                Se você utilizar o conteúdo de terceiros em seu UGC, deve obter
                a devida permissão de forma independente.
            </p>

            <p>
                <strong>O UGC não pode incluir ou expressar o seguinte:</strong>
            </p>

            <ul className='wp-block-list'>
                <li>
                    Qualquer ato que viole leis ou regulamentos, ou infrinja os
                    direitos de terceiros, como direitos de propriedade
                    intelectual, direitos de privacidade, ou direitos de imagem.
                </li>
                <li>Expressão de posições ou pontos de vista políticos.</li>
                <li>
                    Discriminação, depreciação ou discurso de ódio contra grupos
                    específicos, religiões, raças ou gêneros.
                </li>
                <li>
                    Conteúdo obsceno e expressões com conotações sexuais
                    explícitas ou implícitas que outras pessoas possam
                    considerar inadequadas ou ofensivas.
                </li>
                <li>
                    Violência ou atos cruéis que outros possam considerar
                    ofensivos ou inapropriados.
                </li>
                <li>
                    Qualquer conteúdo que viole os valores ou políticas da
                    plyosgames.
                </li>
                <li>Ações contrárias aos bons costumes e à ordem social.</li>
                <li>Conteúdo não adequado para todas as faixas etárias.</li>
            </ul>

            <p>
                Você não pode criar ou distribuir UGC que possa ser confundido
                com conteúdo oficial da plyosgames por outras pessoas.
            </p>

            <p>
                Caso exista UGC que viole os termos deste guia ou leis
                aplicáveis, a plyosgames se reserva o direito de exigir a
                interrupção imediata do uso de IP do jogo e proibir a
                publicação, distribuição ou transmissão desse UGC.
            </p>

            <p>
                O usuário concorda em assumir total responsabilidade pela
                criação de todo conteúdo gerado pelo usuário relacionado aos
                serviços de jogo da plyosgames e por todas as comunicações e
                atividades realizadas no âmbito desses serviços (incluindo
                qualquer outro conteúdo contribuído).
            </p>

            <p>
                O usuário deve isentar e indenizar a plyosgames, sua
                empresa-mãe, afiliadas, e seus respectivos funcionários,
                diretores e executivos por qualquer responsabilidade ou dano
                decorrente de atos relacionados ao uso dos serviços de jogo e
                das plataformas da plyosgames.
            </p>

            <p>
                Em contrapartida ao uso dos serviços e plataformas relacionadas
                da plyosgames, o criador do UGC concede à plyosgames um direito
                exclusivo, perpétuo, irrevogável, totalmente transferível,
                sublicenciável e global para usar o conteúdo contribuído
                relacionado ao software, bens e serviços de qualquer forma e
                para qualquer propósito.
            </p>

            <p>
                Isso inclui o direito de reproduzir, copiar, adaptar, modificar,
                executar, exibir, publicar, transmitir ou comunicar o conteúdo
                ao público por todos os meios conhecidos ou futuros e
                distribuí-lo durante todo o período de proteção da propriedade
                intelectual concedido pela lei aplicável e convenções
                internacionais, sem qualquer notificação ou compensação
                adicional.
            </p>

            <p>
                Na medida permitida por lei, o usuário renuncia a todos os
                direitos morais, de paternidade, publicação, honra ou atribuição
                relacionados ao uso e apreciação desses conteúdos pela
                plyosgames e outros jogadores em conexão com o jogo e produtos
                relacionados. Esta licença concedida à plyosgames e a renúncia
                de direitos morais permanecerão válidas, mesmo após o término ou
                retirada deste contrato.
            </p>

            <p>
                Este guia fornece os princípios básicos a serem seguidos na
                criação de UGC. Ele pode ser revisado sem aviso prévio e
                políticas específicas podem ser aplicadas dependendo de cada
                caso.
            </p>
        </div>
    );
};

export default UGCPolicy;
